/* eslint-disable camelcase */
import React, { useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';

import { selectedPeriodVar } from 'app/apollo/reaction';
import { toUTS } from 'global/utils';

interface IBanner {
    id: string;
    title: string;
    iconPath: string;
    selectionTag: string;
    type: 'selection' | 'link';
    href?: string;
    savingDeliveryСartText?: string
}

interface IDynamicBanner extends IBanner {
    start: number
    end: number
}

// Default
const hits = {
    id: 'hits',
    title: 'Хиты вне времени',
    iconPath: 'hits',
    selectionTag: 'hits',
    type: 'selection',
};
const kids = {
    id: 'kids',
    title: 'Детское меню',
    iconPath: 'kids',
    selectionTag: 'kids',
    type: 'selection',
};
const sweet = {
    id: 'sweets',
    title: 'Печем вместе',
    iconPath: 'sweet',
    selectionTag: 'sweets',
    type: 'selection',
};

// Dynamic
const FirstRowList: IDynamicBanner[] = [
    {
        id: 'kids',
        title: 'Детское меню',
        iconPath: 'kids',
        selectionTag: 'kids',
        type: 'selection',
        start: toUTS('2026-10-05'),
        end: toUTS('2026-11-29'),
    },
    // {
    //     id: 'odyssey',
    //     title: 'К фильму «Одиссея»',
    //     iconPath: 'odyssey',
    //     selectionTag: 'odyssey',
    //     type: 'selection',
    //     start: toUTS('2026-07-20'),
    //     end: toUTS('2026-08-14'),
    // },
    // {
    //     id: 'dacha',
    //     title: 'Всё для шашлыков',
    //     iconPath: 'dacha',
    //     selectionTag: 'dacha',
    //     type: 'link',
    //     href: '/dacha/',
    //     start: toUTS('2026-04-20'),
    //     end: toUTS('2026-04-26'),
    // },
    // {
    //     id: 'hp',
    //     title: 'Еда и сладости из Хогвартса',
    //     iconPath: 'hp',
    //     selectionTag: 'hp',
    //     type: 'selection',
    //     start: toUTS('2025-12-01'),
    //     end: toUTS('2026-02-01'),
    // },
];

const secondRowList: IDynamicBanner[] = [
    {
        id: 'green',
        title: 'Green',
        iconPath: 'green',
        selectionTag: 'green',
        type: 'selection',
        start: toUTS('2026-11-01'),
        end: toUTS('2026-12-28'),
    },
    {
        id: 'hits',
        title: 'Хиты вне времени',
        iconPath: 'hits',
        selectionTag: 'hits',
        type: 'selection',
        start: toUTS('2026-08-15'),
        end: toUTS('2026-11-01'),
    },
    // {
    //     id: 'romantic',
    //     title: 'Время для свиданий',
    //     iconPath: 'romantic',
    //     selectionTag: 'romantic',
    //     type: 'link',
    //     href: '/romantic/',
    //     start: toUTS('2025-02-24'),
    //     end: toUTS('2025-03-10'),
    // },
    // {
    //     id: 'march',
    //     title: 'Великие женщины',
    //     iconPath: 'march',
    //     selectionTag: 'march',
    //     type: 'selection',
    //     start: toUTS('2026-03-16'),
    //     end: toUTS('2026-03-29'),
    // },
    // {
    //     id: 'ny',
    //     title: 'На Новый Год',
    //     iconPath: 'ny',
    //     selectionTag: 'ny',
    //     type: 'link',
    //     href: '/blyuda-dlya-novogodnego-stola/',
    //     start: toUTS('2025-10-13'),
    //     end: toUTS('2025-10-26'),
    // },

    // /practicum.yandex
    // {
    //     id: 'practicum',
    //     title: 'Время для учёбы',
    //     iconPath: 'YaP',
    //     selectionTag: 'YaP',
    //     type: 'selection',
    //     start: toUTS('2025-03-24'),
    //     end: toUTS('2025-04-14'),
    // },
    // {
    //     id: 'marchgifts',
    //     title: 'Подарки к 8 марта',
    //     iconPath: 'marchgifts',
    //     selectionTag: 'marchgifts',
    //     type: 'link',
    //     href: '/marchgifts/',
    //     start: toUTS('2026-02-23'),
    //     end: toUTS('2026-03-08'),
    //     savingDeliveryСartText: 'подарки к 8 марта',
    // },
    // {
    //     id: '2121',
    //     title: 'Постное меню',
    //     iconPath: 'fast',
    //     selectionTag: '2121',
    //     type: 'selection',
    //     start: toUTS('2026-02-16'),
    //     end: toUTS('2026-02-23'),
    // },
];
const ThirdRowList: IDynamicBanner[] = [
    {
        id: 'green',
        title: 'Green',
        iconPath: 'green',
        selectionTag: 'green',
        type: 'selection',
        start: toUTS('2026-10-12'),
        end: toUTS('2026-11-01'),
    },
    {
        id: 'hits',
        title: 'Хиты вне времени',
        iconPath: 'hits',
        selectionTag: 'hits',
        type: 'selection',
        start: toUTS('2026-11-01'),
        end: toUTS('2026-11-22'),
    },
    // {
    //     id: 'gryadka',
    //     title: 'С грядки из деревни',
    //     iconPath: 'gryadka',
    //     selectionTag: 'gryadka',
    //     type: 'selection',
    //     start: toUTS('2026-08-21'),
    //     end: toUTS('2026-09-06'),
    // },
    // {
    //     id: 'maslenitsa',
    //     title: 'Масленица',
    //     iconPath: 'maslenitsa',
    //     selectionTag: 'maslenitsa',
    //     type: 'link',
    //     href: '/maslenitsa/',
    //     start: toUTS('2026-02-09'),
    //     end: toUTS('2026-02-16'),
    // },
];

const getBannerByPeriod = (banner: IDynamicBanner, period: string) => {
    const { start, end } = banner;
    return toUTS(period) >= start && toUTS(period) < end;
};

export const useDynamicUpsellSelections = (setName = 'green') => {
    const period = useReactiveVar(selectedPeriodVar);

    const getBanner = (list: any[], regular = {}) => {
        try {
            const sprcific = list.find(
                (item: IDynamicBanner) => getBannerByPeriod(item, period),
            );
            return sprcific || regular;
        } catch (err) {
            console.error(err);
            return regular;
        }
    };

    const candidate = useMemo(
        () => [
            getBanner(FirstRowList, hits), /* 1st row */
            getBanner(secondRowList, kids), /* 2nd row */
            getBanner(ThirdRowList, sweet), /* 3rd row */
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [period, setName],
    );

    return candidate;
};


/*


// const upsellMlstsSelections: ISelection[] = [
    // {
    //     id: 'green',
    //     title: 'Green',
    //     iconPath: 'green',
    //     selectionTag: 'green',
    //     type: 'selection',
// },
    // {
    //     id: 'hits',
    //     title: 'Хиты вне времени',
    //     iconPath: 'hits',
    //     selectionTag: 'hits',
    //     type: 'selection',
    // },
    // {
    //     id: 'kids',
    //     title: 'Детское меню',
    //     iconPath: 'kids',
    //     selectionTag: 'kids',
    //     type: 'selection',
    // },

    // {
    //     id: 'harry',
    //     title: 'Меню из Хогвартса',
    //     iconPath: 'harry',
    //     selectionTag: 'hp',
    //     type: 'selection',
    // },
    // {
    //     id: 'green',
    //     title: 'Green',
    //     iconPath: 'green',
    //     selectionTag: 'green',
    //     type: 'selection',
    // },
    // {
    //     id: 'maxim',
    //     title: 'Вечер с любимыми',
    //     iconPath: 'maxim',
    //     selectionTag: 'maxim',
    //     type: 'selection',
    // },
    // {
    //     id: 'film',
    //     title: 'Дома, как в кино',
    //     iconPath: 'film',
    //     selectionTag: 'film',
    //     type: 'selection',
    // },
    // {
    //     id: 'dacha',
    //     title: 'На дачу',
    //     iconPath: 'dacha',
    //     selectionTag: 'dacha',
    //     type: 'link',
    //     href: '/dacha',
    // },
// ];


// const upsellMarchgifts = [];

// const upsellFast = [
//     {
//         id: '2121',
//         title: 'Пост',
//         iconPath: 'fast',
//         selectionTag: '2121',
//         type: 'selection',
//     },
//     {
//         id: 'kids',
//         title: 'Детское меню',
//         iconPath: 'kids',
//         selectionTag: 'kids',
//         type: 'selection',
//     },
// ];


// const upsellSelections = useMemo(() => {
//     if (setName === 'maslenitsa') {
//         return upsellMlstsSelections;
//     }

//     if (setName === 'marchgifts') {
//         return upsellMarchgifts;
//     }

//     if (setName === 'march') {
//         return upsellFast;
//     }

//     return upsellDefault;
// }, [setName]);


*/
